import { environment } from 'src/environments/environment';
import { CommonResponse } from 'src/app/models/responses/common-response';
import { RequestService } from 'src/app/services/request.service';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { IUserResponse } from '../models/responses/user-response';
import { User } from '../models/user';

@Injectable({
  providedIn: 'root',
})
export class UserAdminService {
  constructor(private requestService: RequestService) {}

  /**
   *
   * @param page
   * @param count
   * @returns
   */
  public getUser(data: {
    page: number;
    count: number;
    search?: string;
    department?: string;
    division?: string;
    role?: number;
    is_active?: boolean;
  }): Observable<IUserResponse> {
    return this.requestService.postJSON<IUserResponse>(`/user`, {
      data: Object.assign(data),
      option: {
        is_loading: true,
      },
    });
  }

  /**
   *
   * @param page
   * @param count
   * @returns
   */
  public getUserByID(id: string): Observable<CommonResponse<User>> {
    return this.requestService.getJSON<User>(`/user/${id}`, {
      data: {},
      option: {
        is_loading: true,
      },
    });
  }

  /**
   *  UPDATE USER PROFILE
   * @param file
   * @param id
   * @returns
   */
  public updateUserProfile(
    file: any,
    id: string,
  ): Observable<CommonResponse<User>> {
    const formData = new FormData();
    formData.append('avatar', file);

    return this.requestService.patchJSON<any>(`/user/${id}/avatar`, {
      data: Object.assign(formData),
      option: {
        is_loading: true,
      },
    });
  }

  public createUserProfile(file: any): Observable<CommonResponse<User>> {
    const formData = new FormData();
    formData.append('avatar', file);

    return this.requestService.postJSON<any>(`/user/upload/avatar`, {
      data: Object.assign(formData),
      option: {
        is_loading: true,
      },
    });
  }

  /**
   *
   * @param data
   * @returns
   */
  public createUser(data: any): Observable<CommonResponse<User>> {
    return this.requestService.postJSON<CommonResponse<User>>(`/user/create`, {
      data,
      option: {
        is_loading: true,
        is_snack_bar: true,
        is_localize_msg: true,
      },
    });
  }

  /**
   *
   * @param data
   * @returns
   */
  public updateUser(data: any, id: string): Observable<CommonResponse<User>> {
    return this.requestService.patchJSON<CommonResponse<User>>(`/user/${id}`, {
      data,
      option: {
        is_loading: true,
        is_snack_bar: true,
        is_localize_msg: true,
      },
    });
  }

  toggleActive(
    id: string,
    is_active: boolean,
  ): Observable<CommonResponse<User>> {
    let path = '/user/active/' + id;
    return this.requestService.patchJSON<CommonResponse<User>>(
      path,
      {
        data: { is_active },
        option: {
          is_loading: true,
        },
      },
      true,
    );
  }

  getUserByDepartment(
    department: string,
    page: number,
    count: number,
    search?: string,
  ): Observable<IUserResponse> {
    const path = `/user`;
    return this.requestService.postJSON<IUserResponse>(path, {
      data: { page, count, department, is_active: true, search },
      option: {
        is_loading: true,
      },
    });
  }

  getAvatar(avatarId: string): Observable<Blob> {
    return this.requestService.get<Blob>(
      '/user/avatar/' + avatarId,
      {
        data: null,
        option: {},
      },
      'blob',
    );
  }

  public manageUpdateBranches(
    data: any,
    id: string,
  ): Observable<CommonResponse<User>> {
    return this.requestService.patchJSON<CommonResponse<User>>(
      `/user/${id}/branches`,
      {
        data,
        option: {
          is_loading: true,
          is_snack_bar: true,
          is_localize_msg: true,
        },
      },
    );
  }
  public uploadSingature(file: any): Observable<CommonResponse<User>> {
    const formData = new FormData();
    formData.append('signature', file);
    return this.requestService.postJSON<any>(`/user/upload/signature`, {
      data: Object.assign(formData),
      option: {
        is_loading: true,
      },
    });
  }

  public getAttachment(_id: string): Observable<Blob> {
    return this.requestService.get(
      `/user/attachment/${_id}`,
      {
        data: null,
        option: {
          is_loading: true,
        },
      },
      'blob',
    );
  }

  searchOldEnterpriseUser(search: string): Observable<CommonResponse<any>> {
    let path = '/ent-user/' + 'existing/search';
    return this.requestService.postJSON(path, {
      data: { search },
      option: {
        is_loading: true,
      },
    });
  }

  searchNssfUser(search: string): Observable<CommonResponse<any>> {
    let path = '/user/existing/search';
    return this.requestService.postJSON(path, {
      data: { search },
      option: {
        is_loading: true,
      },
    });
  }

  nssfUserList(data?: any): Observable<CommonResponse<any>> {
    let path = '/user/existing/search';
    return this.requestService.postJSON(path, {
      data,
      option: {
        is_loading: true,
      },
    });
  }
}
